import { render, staticRenderFns } from "./admin-dashboard-main.vue?vue&type=template&id=7c0ead19&"
import script from "./admin-dashboard-main.vue?vue&type=script&lang=js&"
export * from "./admin-dashboard-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports